<template>
  <v-dialog persistent v-model="dialog" content-class="bg-white font-lato p-4" max-width="608"  
    style="border-radius: 0.25rem !important;">
    <div class="mb-6">
      <h4 class="mb-0">Rename Column Label</h4>
    </div>
    <form @submit.prevent="handleSubmit">
      <div class="">
        <div class="d-flex flex-column" style="gap: 16px;">
          <div class="input">
            <label for="label">Label</label>
            <CInput v-model.trim="label" :placeholder="'Label'" :inputType="'text'" :required="true"></CInput>
          </div>
        </div>
      </div>

      <div class="buttons d-flex justify-content-end mt-6">
        <div class="btn btn-outline-primary mr-2" @click="closeModal()">
          Cancel
        </div>
        <button type="submit" class="btn btn-primary">
          Rename
        </button>
      </div>
    </form>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import CInput from '../../c-input.vue'

export default {
  components: {
    CInput,
  },
  props: {
    dialog: Boolean,
    type: String,
    dataColumn: Object,
  },
  data() {
    return {
      label: '',
      timeoutId: null,
    }
  },
  computed: {
    ...mapState({
      
    }),
    ...mapGetters({
      hasUnsavedChanges: "reportTemplates/hasUnsavedChanges",
    }),
  },
  methods: {
    ...mapActions({
      updateColumnLabel: 'reportTemplates/updateColumnLabel',
    }),
    async handleSubmit() {
      this.updateColumnLabel({
        columnName: this.dataColumn.columnName,
        group: this.dataColumn.group,
        header_name: this.label
      });

      this.$store.commit('reportTemplates/setUnsavedChanges', this.hasUnsavedChanges);
      this.closeModal();
    },
    resetForm() {
      this.label = ''
    },
    closeModal() {
      this.$emit('toggle-modal', false);
      this.resetForm();
    },
    handleCloseOutside(e) {
      const overlay = document.getElementsByClassName('v-overlay__scrim');
      if (overlay[0] && overlay[0].contains(e.target)) {
        this.closeModal();
      }
    },
  },
  mounted() {
    this.timeoutId = setTimeout(() => {
    
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId);
     
  },
  watch: {
    dataColumn: {
      immediate: true,
      handler(dataLabel) {
        this.label = dataLabel.header_name || "";
      },
    },
  },
}
</script>